<div *ngIf="isLoading | async" class="loader-overlay">
  <div class="flex items-center justify-center flex-col loader-content">
    <p-progressSpinner></p-progressSpinner>
    <div class="mt-4" *ngIf="showText">{{'loading.processing.label' | translate}}</div>
  </div>
</div>